module.exports = __webpack_public_path__ + "static/img/bg-kiko.eb1f41ae.png";